import React from "react";
import styles from "../style.module.scss";
import Endpoint from "./Endpoint";

export default function Endpoints({ specs }) {
    if (!Array.isArray(specs) || specs.length === 0) return null;

    return (
        <>
            {specs.map((spec, index) => (
                <React.Fragment key={`${spec.method}-${spec.path}-${index}`}>
                    {index === 0 && <div style={{ marginTop: 40 }} />}
                    <Endpoint spec={spec} />
                    {index < specs.length - 1 && (
                        <div className={styles.spacerPadded} />
                    )}
                </React.Fragment>
            ))}
        </>
    );
}
